// component
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import WorkIcon from '@mui/icons-material/Work';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import PersonIcon from '@mui/icons-material/Person';
import DashboardSharpIcon from '@mui/icons-material/DashboardSharp';
import LocationOnSharpIcon from '@mui/icons-material/LocationOnSharp';
import PaidSharpIcon from '@mui/icons-material/PaidSharp';
import DirectionsCarSharpIcon from '@mui/icons-material/DirectionsCarSharp';
import CategorySharpIcon from '@mui/icons-material/CategorySharp';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import EventNoteIcon from '@mui/icons-material/EventNote';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined';
import ReceiptIcon from '@mui/icons-material/Receipt';
import BeachAccessIcon from '@mui/icons-material/BeachAccess';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import BookOnlineIcon from '@mui/icons-material/BookOnline';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import EditCalendarIcon from '@mui/icons-material/EditCalendar';
import AssignmentIcon from '@mui/icons-material/Assignment';
import GroupsIcon from '@mui/icons-material/Groups';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import ChecklistIcon from '@mui/icons-material/Checklist';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import AssessmentIcon from '@mui/icons-material/Assessment';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import MapIcon from '@mui/icons-material/Map';
import BusinessIcon from '@mui/icons-material/Business';
import PaidIcon from '@mui/icons-material/Paid';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import CategoryIcon from '@mui/icons-material/Category';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import TuneIcon from '@mui/icons-material/Tune';

// ----------------------------------------------------------------------

export const navConfig = () => {
  const navConfigAdmin = [
    {
      title: 'dashboard',
      path: '/dashboard/app',
      icon: <DashboardSharpIcon />,
    },
    {
      title: 'Job/Project',
      path: '/job/list',
      icon: <WorkIcon />,
    },
    {
      title: 'Rate Sheet',
      path: '/rate-sheet/list',
      icon: <LocalAtmIcon />,
    },
    {
      title: 'Client',
      path: '/client/list',
      icon: <PermContactCalendarIcon />,
    },
    // {
    //   title: 'Quote',
    //   path: '/quote/list',
    //   icon: <RequestQuoteOutlinedIcon />,
    // },
    {
      title: 'Task',
      path: '#',
      icon: <ChecklistIcon />,
      child: [
        {
          title: 'Active Task',
          path: '/taskactive/list',
          icon: <PendingActionsIcon />,
        },
        {
          title: 'Complete Task',
          path: '/taskcomplete/list',
          icon: <TaskAltIcon />,
        },
      ],
    },
    {
      title: 'Schedules & Drafts',
      path: '#',
      icon: <CalendarMonthIcon />,
      child: [
        {
          title: 'Job Schedule',
          path: '/scheduling/calander_view',
          icon: <EventAvailableIcon />,
        },
        {
          title: 'To Do Draft',
          path: '/scheduling/todo_draft',
          icon: <EditCalendarIcon />,
        },
      ],
    },
    {
      title: 'Daily Work Report',
      path: '/dwr/list',
      icon: <AssignmentIcon />,
    },
    {
      title: 'Invoice',
      path: '/invoice/list',
      icon: <ReceiptLongIcon />,
    },
    {
      title: 'Report',
      path: '/report/list',
      icon: <AssessmentIcon  />,
    },
    {
      title: 'Masters',
      path: '/master/dashboard',
      icon: <ManageAccountsIcon  />,
      child: [
        {
          title: 'City',
          path: '/master/city/list',
          icon: <LocationCityIcon  />,
        },
        {
          title: 'State',
          path: '/master/state/list',
          icon: <MapIcon  />,
        },
        {
          title: 'Office',
          path: '/master/office/list',
          icon: <BusinessIcon  />,
        },
        // {
        //   title: 'Tax',
        //   path: '/master/tax/list',
        //   icon: <PaidIcon  />,
        // },
        // {
        //   title: 'Fee',
        //   path: '/master/fee/list',
        //   icon: <RequestQuoteIcon  />,
        // },
        {
          title: 'Invoice Defaults',
          path: '/master/Invoice_Defaults/list',
          icon: <TuneIcon  />,
        },
        {
          title: 'Payment Term',
          path: '/master/paymentterm/list',
          icon: <EventRepeatIcon  />,
        },
        {
          title: 'Client Type',
          path: '/master/clienttype/list',
          icon: <GroupsIcon  />,
        },
        {
          title: 'Job Category',
          path: '/master/jobcategory/list',
          icon: <WorkOutlineIcon  />,
        },
        {
          title: 'Job Status',
          path: '/master/jobstatus/list',
          icon: <FactCheckIcon  />,
        },
        {
          title: 'Job Scope',
          path: '/master/jobscope/list',
          icon: <AccountTreeIcon  />,
        },
        {
          title: 'Cost Item',
          path: '/master/costitem/list',
          icon: <CategoryIcon  />,
        },
        {
          title: 'Vehicle',
          path: '/master/vehicle/list',
          icon: <DirectionsCarIcon  />,
        },
      ],
    },
    {
      title: 'Holidays',
      path: '/holidays/list',
      icon: <BeachAccessIcon />,
    },
    {
      title: 'Employee Leaves',
      path: '/employee_leaves/calander_view',
      icon: <EventBusyIcon />,
    },
    {
      title: 'Prebooking',
      path: '/prebooking/calander_view',
      icon: <BookOnlineIcon />,
    },
    {
      title: 'user',
      path: '/user/list',
      icon: <PersonIcon />,
    },
  ];
  const navConfigManager = [
    {
      title: 'dashboard',
      path: '/dashboard/app',
      icon: <DashboardSharpIcon />,
    },
    {
      title: 'Job/Project',
      path: '/manager/job/list',
      icon: <WorkIcon />,
    },
    {
      title: 'Client',
      path: '/manager/client/list',
      icon: <PermContactCalendarIcon />,
    },

    // {
    //   title: 'Quote',
    //   path: '/manager/quote/list',
    //   icon: <RequestQuoteOutlinedIcon />,
    // },
    {
      title: 'Task',
      path: '#',
      icon: <ChecklistIcon  />,
      child: [
        {
          title: 'Active Task',
          path: '/manager/taskactive/list',
          icon: <PendingActionsIcon />,
        },
        {
          title: 'Complete Task',
          path: '/manager/taskcomplete/list',
          icon: <TaskAltIcon />,
        },
      ],
    },
    {
      title: 'Schedules & Drafts',
      path: '#',
      icon: <CalendarMonthIcon  />,
      child: [
        {
          title: 'Job Schedule',
          path: '/scheduling/calander_view',
          icon: <EventAvailableIcon  />,
        },
        {
          title: 'To Do Draft',
          path: '/scheduling/todo_draft',
          icon: <EditCalendarIcon  />,
        },
      ],
    },
    {
      title: 'Daily Work Report',
      path: '#',
      icon: <AssignmentIcon  />,
      child: [
        {
          title: 'Staff Report',
          path: '/manager/dwrstaff/list',
          icon: <GroupsIcon  />,
        },
        {
          title: 'Work Report',
          path: '/manager/dwr/list',
          icon: <FactCheckIcon  />,
        },
      ],
    },
    {
      title: 'Invoice',
      path: '/manager/invoice/list',
      icon: <ReceiptLongIcon  />,
    },
    {
      title: 'Holidays',
      path: '/holidays/list',
      icon: <BeachAccessIcon />,
    },
    {
      title: 'Employee Leaves',
      path: '/employee_leaves/calander_view',
      icon: <EventBusyIcon />,
    },
    {
      title: 'Prebooking',
      path: '/prebooking/calander_view',
      icon: <BookOnlineIcon />,
    },
  ];
  const navConfigEmployee = [
    {
      title: 'dashboard',
      path: '/dashboard/app',
      icon: <DashboardSharpIcon />,
    },
    {
      title: 'Daily Work Report',
      path: '/staff/dwr/list',
      icon: <AssignmentIcon />,
    },
    {
      title: 'Schedules & Drafts',
      path: '#',
      icon: <CalendarMonthIcon />,
      child: [
        {
          title: 'Job Schedule',
          path: '/scheduling/calander_view',
          icon: <EventAvailableIcon />,
        },
        {
          title: 'To Do Draft',
          path: '/scheduling/todo_draft',
          icon: <EditCalendarIcon />,
        },
      ],
    },
    {
      title: 'Holidays',
      path: '/holidays/list',
      icon: <BeachAccessIcon />,
    },
  ];
  return { admin: navConfigAdmin, employee: navConfigEmployee, manager: navConfigManager };
};
